import { getMessages } from 'app/store/constants';

export const UPDATES_TIPS_OF = getMessages().getText('common.of');
